import {HeadFilterOperator} from 'simplifyworks-core-ui';

export const FOEDUS_ROLE = {
	COORDINATOR: 'foedus_coo',
	COUNTRY_MANAGER: 'foedus_country_manager',
	ADMIN: 'foedus_admin'
};

// Filtre na BE este nie su pripravene na handlovat ine operatory ako equals
export const equalsOnlyHeadFilterOperators = Object.entries(HeadFilterOperator)
	.filter(([key]) => key !== 'EQUALS')
	.map(([, value]) => value);

export const likeUnaccentOnlyHeadFilterOperators = Object.entries(HeadFilterOperator)
	.filter(([key]) => key !== 'LIKE_UNACCENT')
	.map(([, value]) => value);

export const organOfferIdByEnv = {
	'http://localhost:8084': 18267,
	'https://foedus-dev.ders.cz': 18267,
	'https://foedus-test.ders.cz': 18659,
	'https://staging.foedus-eoeo.eu': 31667,
	'https://portal.foedus-eoeo.eu': 29464
};
